var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1455_11101",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0007 3.3335C10.4609 3.3335 10.834 3.70659 10.834 4.16683V9.16683H15.834C16.2942 9.16683 16.6673 9.53993 16.6673 10.0002C16.6673 10.4604 16.2942 10.8335 15.834 10.8335H10.834V15.8335C10.834 16.2937 10.4609 16.6668 10.0007 16.6668C9.54041 16.6668 9.16732 16.2937 9.16732 15.8335V10.8335H4.16732C3.70708 10.8335 3.33398 10.4604 3.33398 10.0002C3.33398 9.53993 3.70708 9.16683 4.16732 9.16683H9.16732V4.16683C9.16732 3.70659 9.54041 3.3335 10.0007 3.3335Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1455_11101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.84ea6a9c.svg";
export { ForwardRef as ReactComponent };